import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject, Observable } from 'rxjs';
import { first, map, tap } from 'rxjs/operators';
import { Counter, indicateWithCounter } from 'src/app/operators';
import {
  CoatViewModel,
  EsraCoatingsAPIClient
} from 'src/app/shared/models/autogenerated-coating';

@Component({
  selector: 'app-add-coat-dialog',
  templateUrl: './add-coat-dialog.component.html',
  styleUrls: ['./add-coat-dialog.component.scss'],
  standalone: false,
})
export class AddCoatDialogComponent implements OnInit {
  formGroup: UntypedFormGroup;
  coatNames$: Observable<string[]>;
  genericClassifications$: Observable<string[]>;
  loadingCoat$ = new BehaviorSubject<boolean>(false);
  coatingSystemGuid: string;
  coatingSystemId: string;

  constructor(
    public dialogRef: MatDialogRef<AddCoatDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private readonly _formBuilder: UntypedFormBuilder,
    private readonly _esraCoatingClient: EsraCoatingsAPIClient
  ) {}

  ngOnInit(): void {
    if (this.data) {
      this.coatingSystemGuid = this.data.coatingSystemGuid;
      console.log(this.data);
    }
    let counter = new Counter();
    this.formGroup = this._formBuilder.group({
      coatName: ['', Validators.required],
      genericClassification: ['', Validators.nullValidator],
      dft: ['', Validators.nullValidator],
      notes: ['', Validators.nullValidator],
    });
    this.coatNames$ = this._esraCoatingClient.getCoatNames().pipe(
      indicateWithCounter(this.loadingCoat$, counter),
      map((names) => names.map((n) => n.id)),
      first()
    );
    this.genericClassifications$ = this._esraCoatingClient
      .getCoatPropertyValues('genericClassification')
      .pipe(indicateWithCounter(this.loadingCoat$, counter), first());
  }

  save() {
    const newCoat = new CoatViewModel({
      coatingSystemId: this.coatingSystemGuid,
      coatName: this.formGroup.value.coatName,
      genericClassification: this.formGroup.value.genericClassification,
      dft: this.formGroup.value.dft,
      notes: this.formGroup.value.notes,
    });

    let counter = new Counter();

    this._esraCoatingClient.addCoatToCoatingSystem(newCoat)
      .pipe(indicateWithCounter(this.loadingCoat$, counter),
      first(),
      tap((result) =>  {
        this.dialogRef.close(result);
      }))
      .subscribe();

  }

  cancel() {
    this.dialogRef.close();
  }

}
